import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'slice'
})
export class SlicePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
